import React, { memo } from "react";
import Widget from "../Widget";
import BannersTable from "components/Admin/Tables/BannersTable";

interface Props {}

const BannersWidget: React.FC<Props> = () => {
  return (
    <Widget title="Банери">
      <BannersTable />
    </Widget>
  );
};

export default memo(BannersWidget);
